import { render } from "./MyTaskManager.vue?vue&type=template&id=7741ec6a&ts=true"
import script from "./MyTaskManager.vue?vue&type=script&lang=ts"
export * from "./MyTaskManager.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__